module.exports = __webpack_public_path__ + "img/bannerHome2.3f2c26a2.webp";